<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('sendNotifications.title') }}</h6>
          <p class="font13 gray-col">
            {{ $t('sendNotifications.subtitle') }}
          </p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('sendNotifications.notificationsTitle') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addNoti" v-model="valid" ref="form">
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('sendNotifications.arabicTitle') }}</h6>
                <v-text-field
                  type="text"
                  name="subject[ar]"
                  :rules="defaultRoles"
                  :placeholder="$t('sendNotifications.arabicTitlePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('sendNotifications.englishTitle') }}</h6>
                <v-text-field
                  type="text"
                  name="subject[en]"
                  :rules="defaultRoles"
                  :placeholder="$t('sendNotifications.englishTitlePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mb-4">
                <h6 class="mb-2 font14">{{ $t('sendNotifications.building') }}</h6>
                <Dropdown
                  v-model="selectedBuilding"
                  :options="buildingType"
                  filter
                  optionLabel="name"
                  :placeholder="$t('sendNotifications.buildingPlaceholder')"
                  :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                  class="main-select"
                />
              </div>

              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('sendNotifications.arabicContent') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  name="text[ar]"
                  rows="7"
                  :placeholder="$t('sendNotifications.arabicContentPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('sendNotifications.englishContent') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  name="text[en]"
                  rows="7"
                  :placeholder="$t('sendNotifications.englishContentPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont mt-1 mb-4">
                <h6 class="mb-3">استخدام العقار</h6>
                <div class="flex-big-gap">
                  <div class="all-container-type">
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        name="members"
                        value="all"
                        id="all"
                        class="mainRadio"
                      />
                      <label for="all" class="font14">{{ $t('sendNotifications.sendToAll') }}</label>
                    </div>
                  </div>
                  <div class="all-container-type">
                    <!-- <h6 class="styleOnly mb-3">styleOnly</h6> -->
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        id="owners"
                        name="members"
                        value="owners"
                        class="mainRadio"
                      />
                      <label for="owners" class="font14">{{ $t('sendNotifications.sendToOwners') }}</label>
                    </div>
                  </div>
                  <div class="all-container-type">
                    <!-- <h6 class="styleOnly mb-3">styleOnly</h6> -->
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        id="tenant"
                        name="members"
                        value="users"
                        class="mainRadio"
                      />
                      <label for="tenant" class="font14">{{ $t('sendNotifications.sendToTenants') }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('sendNotifications.send') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('sendNotifications.sending') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import Dropdown from "primevue/dropdown";
import { useToast } from "primevue/usetoast";
import axios from "axios";
const toast = useToast();
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

// reactive state
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('sendNotifications.fieldRequired');
  },
]);

const valid = ref(false);
const form = ref(null);
const disabled = ref(false);
const selectedBuilding = ref(null);
const buildingType = ref([]);

// functions
function getBuildings() {
  axios
    .get("/manager/buildings", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      buildingType.value = response.data.data;
    });
}
function sendNotification() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);

  if (selectedBuilding.value) {
    fd.append("building_id", selectedBuilding.value.id);
  }

  axios
    .post("/manager/send-notification", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        form.value.reset();
        selectedBuilding.value = null;
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
// addBuilding
function addNoti() {
  if (valid.value) {
    sendNotification();
  } else {
    scrollToDanger();
  }
}
// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {
  getBuildings();
});
</script>
